import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { components } from '@bookingdei/api-client/types';
import { api } from '../../api';
import { useLanguage } from '../../shell/language-context';
import { HxListingCard } from './hx-listing-card';
import { Ic } from './hx-icon';
import { placeSponsored } from './place-sponsored';
import type { HomeFormat } from './use-home-format';

type BusinessSummary = components['schemas']['BusinessSummary'];
type SearchResults = components['schemas']['SearchResults'];

// "Popular near you." (design `.sec`, grid of eight): the organic cards with the one
// sponsored placement at slot 3 (the server flags it, AP-D10 — the client only places it),
// the count of places search would return unfiltered, and "All listings" into /search.
export function HxPopular({ nearby, fmt }: { nearby: BusinessSummary[]; fmt: HomeFormat }) {
  const { t, lang } = useLanguage();
  const [total, setTotal] = useState<number | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    api
      .GET('/search', { params: { query: { limit: 1 } }, signal: controller.signal, lang })
      .then((r: SearchResults) => setTotal(r.total_estimate ?? null))
      .catch(() => undefined);
    return () => controller.abort();
  }, [lang]);
  const cards = placeSponsored(nearby, 2, 7).slice(0, 8);
  if (cards.length === 0) return null;
  return (
    <section className="sec">
      <div className="in">
        <div className="sh rv">
          <div>
            <h2>{t('dc50.popular.title')}</h2>
            {total !== null ? <p>{t('dc50.popular.places_in', { n: fmt.num(total) })}</p> : null}
          </div>
          <Link className="more" to="/search">
            {t('hx.popular.all')} <Ic id="arrow" />
          </Link>
        </div>
        <div className="g4">
          {cards.map((b) => (
            <HxListingCard key={b.id} business={b} fmt={fmt} />
          ))}
        </div>
        <p className="foot rv">{t('dc50.popular.rankings_note')}</p>
      </div>
    </section>
  );
}
